import StagePage from '../stage/StagePage';

export default function Round2Page() {
  return <StagePage stage={2} />;
}
